import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h6>{`簡介`}</h6>
    <ul>
      <li parentName="ul">{`Design Sprint Taiwan 社群組織者`}</li>
      <li parentName="ul">{`Scrum Drawing Game 發明者 / VSM 帥哥早餐店工作坊發明者 / 敏捷內容創作者`}</li>
      <li parentName="ul">{`在新創公司打造端到端跨職能敏捷團隊。`}</li>
    </ul>
    <h6>{`經歷`}</h6>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`14 年軟體開發經驗 (M17、HandsUP、趨勢科技、寶碩財務科技)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`6 年敏捷導入經驗 (M17、HandsUP、趨勢科技、中國信託、新創公司)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`多次敏捷演講經驗 (Agile Tour、Agile Summit、DevOpsDays、Top100Case 北京)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`多次敏捷公開課程 (Agile Tour、Agile Summit、DevOpsDays、MPD 软件工作坊深圳)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`個人 Blog: `}<a parentName="p" {...{
            "href": "https://medium.com/juggernauts-agile-stories"
          }}>{`https://medium.com/juggernauts-agile-stories`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Youtube : JUGG 聊敏捷 `}<a parentName="p" {...{
            "href": "https://www.youtube.com/channel/UCLHs-lL9v4YaV-IvMyaRckw"
          }}>{`https://www.youtube.com/channel/UCLHs-lL9v4YaV-IvMyaRckw`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Facebook Page: Jugg 聊敏捷 `}<a parentName="p" {...{
            "href": "https://www.facebook.com/juggnotes/"
          }}>{`https://www.facebook.com/juggnotes/`}</a></p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      